
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sftp",
      function () {
        return require("private-next-pages/destinations/sftp.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sftp"])
      });
    }
  